import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../firebase";

const GetAllSports = async (uid, SchoolID) => {
  if (uid && SchoolID) {
    try {
      const SportsCollection = collection(db, "Sports");

      const q = query(
        SportsCollection,
        where("uid", "==", uid),
        where("SchoolID", "==", SchoolID),
        where("IsDeleted", "==", false)
      );
      const SportsSnapshot = await getDocs(q);

      let SportsData = [];

      SportsSnapshot.forEach((doc) => {
        SportsData.push({ ...doc.data(), id: doc.id });
      });
      return SportsData;
    } catch (error) {
      console.log(error);
    }
  }
};

export default GetAllSports;
